








































import CFMDialog from '@/scripts/CFMDialog'
import { Component } from 'vue-property-decorator';

import * as blockui from '@/helpers/block-ui'

import { required } from "vuelidate/lib/validators";

import { CFMDTOFailureMode } from '@/scripts/services/ClientApiAuto'

@Component<FailureTypeDialog>({
    validations() {
        return {
            failureType: {
                Name: { required }
            }
        }
    },
})
export default class FailureTypeDialog extends CFMDialog {
    failureType: CFMDTOFailureMode = { Name: '' };

    async created() {
        blockui.blockModal(this);
        if (this.isUpdate) {
            const res = await this.apiClient.failureType.failureTypeGetById({ id: <number>this.id });
            console.log(res);
            this.failureType = res.data;
        }
        blockui.unBlockModal();
    }

    async onSubmit() {
        this.$v.$touch();
        if (this.$v.$invalid) {
            return;
        }
        let formData = {
            Id: this.failureType.Id,
            Name: this.failureType.Name.trim(),
        };
        blockui.blockModal(this);
        try {
            const response = await this.apiClient.failureType.failureTypeSave(formData);
            if (response.data.IsSuccess) {
                toastr.success(this.translate('save_successfully'));
                this.saveSucceeded();
                this.close();
            } else {
                const errorMessage = response.data.Message ? response.data.Message : "Error";
                toastr.error(errorMessage);
            }
        } catch (e) {
            console.log("err", e)
            toastr.error(e);
        } finally {
            blockui.unBlockModal();
        }
    }
}
